<template>
    <div class="shadow-lg shadow-gray-400 rounded-md mb-6">
        <div class="bg-white p-3 font-bold rounded-md flex justify-between" @click="showResume = !showResume">
            Resumo do curso 
            <Icon class="text-xl" icon="iconamoon:arrow-down-2-thin" :rotate="2" v-if="showResume" />
            <Icon class="text-xl" icon="iconamoon:arrow-down-2-thin" v-else />
        </div>
        <div class="gray-light p-4 rounded-bl-md rounded-br-md text-xs	" v-show="showResume">
            <div class="flex">
                <div class="w-1/2">
                    <p v-if="product?.academic_degree?.name">Tipo: <b>{{product?.academic_degree?.name}}</b></p>
                    <p v-if="product?.starts_in">Ínicio: <b>{{ product?.starts_in }}</b></p>
                </div>
                <div class="w-1/2" v-if="product?.duration">
                    <p>Duração: <b>{{product?.duration}}</b></p>
                </div>						
            </div>
            <hr class="bg-white my-3" />
            <div class="flex">
                <div class="w-1/3" v-if="product?.modality.name"><b>Modalidade</b>:<br /> {{product?.modality.name}}</div>
                <div class="w-1/3" v-if="product?.shift.name"><b>Período</b>:<br /> {{product?.shift.name}}</div>
                <div class="w-1/3" v-if="product?.city.name"><b>Cidade</b>:<br /> {{product?.city.name}}</div>
            </div>
        </div>
    </div>
</template>
  
<script lang="ts" setup>
    import { Icon } from "@iconify/vue";
    import { storeToRefs } from "pinia";
	import { useCheckoutStore } from "~/store/checkout";

	const checkout = useCheckoutStore();
    const { product } = storeToRefs(checkout);
    const showResume = ref(false);
</script>
  
<style scoped>
.timer {
    font-size: 2em;
}

.number {
    display: inline-block;
    transition: all 0.5s ease;
}

.number.animate {
  animation-name: fallDown;
  animation-duration:  0.5s;
  animation-fill-mode: forwards;
}

@keyframes fallDown {
   0% {
    opacity:  1;
    transform: translateY(0);
  }
   100% {
    opacity:  0;
    transform: translateY(100%);
  }
}

.number {
    animation-name: fallDown;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
}</style>